export function pngRenderer(param: { value: string }) {
  return `<img src='/${param.value}' width="100" height="80" />`;
}
